import React, { useEffect, useState } from "react";
import Button from "@src/components/UIElements/Button";
import styles from "./Layout.module.scss";
import Loader from "@src/components/UIElements/Loader";
import { initialisePaymentService } from "@src/PaymentService";
import { directDeepLink } from "@src/common/deepLinks/index.js";
import { useSelector, useDispatch } from "react-redux";
import { openInstallmentUtil } from "../components/Tabs/Overview/components/OverviewContent/utility";
import { newWebEngage } from "@src/utils/webEngageEvent";
import { useTranslation } from "react-i18next";
import CheckoutOptionsBottomSheet from "../components/BottomSheets/components/CheckoutOptionsBottomSheet/CheckoutOptionsBottomSheet";
import {
  courseFacultyListModalAction,
  setNotSupportedBottomsheet,
  showApplyCouponBottomSheetAction,
  showCourseAccessRemoveBottomSheetAction,
  showEnrollForFreeCourseBottomSheetAction,
  showLockedFreeCourseBottomSheetAction,
  showSelectDynamicBundlingBottomSheetAction,
} from "../components/BottomSheets/store/actions";
import { captureInterest } from "../components/Tabs/Overview/store/actions";
import CourseAccessRemovedBottomSheet from "../components/BottomSheets/components/CourseAccessRemovedBottomSheet/CourseAccessRemovedBottomSheet";
import { quitWebviewDeeplink } from "@src/utils/goBack";
import { useRouter } from "@src/lib/router";
import LockedModal from "../components/Tabs/Content/components/ContentList/LockedModal";
import PrepurchageIdfys from "../components/Tabs/Overview/components/idfys/prepurchageIdfys/PrepurchageIdfys";
import * as actionCreator from "../components/BottomSheets/store/actions";
import { getAwsAssets } from "@src/utils";
import { Image } from "@src/components/Image";
import { updateIntroVideo }  from "../components/BottomSheets/components/IntroVideoBottomSheet/store/service";
import CONSTANTS from "../components/BottomSheets/store/constants";
import { UPI_APP_ICONS } from "@src/utils/constants";
import { safeJsonParse } from "@src/utils/safeJsonParse";

function BuyNowFooter({
  children,
  isInstallment,
  isInstallmentCompleted,
  buttonText,
  getCourseCouponListStudentDataServer,
  isFreeCourse = 0
}) {
  const [shareableLiveClassEventType, setShareableLiveClassEventType] = useState("");
  const [isIdfyEmailVerificationEnabled, setIsIdfyEmailVerificationEnabled] = useState(false);
  const [isIdfyUserVerified, setIsIdfyUserVerified] = useState(false);
  // UPI apps state

  const [intentToken, setIntentToken] = useState(null);
  const[selectedUpiApp, setSelectedUpiApp] = useState(null);
  const [pkgName, setPkgName] = useState(null);
  const isOneTimeCheckoutEnabled = useSelector((state) => state?.persistedDataReducer?.orgDetails?.organization?.isOneClickCheckoutEnabled)

    useEffect(() => {
      if (window?.mobile?.getInstalledUpiApps) {
        try {
          const response = window.mobile.getInstalledUpiApps();
          const upiApps = safeJsonParse(response, {
            source: "BuyNowFooter [getInstalledUpiApps]",
            fallback: [],
          });
          const upiAppsJson = upiApps[0]; // Assuming we take the first available UPI app
          if(isOneTimeCheckoutEnabled){
            setIntentToken(upiAppsJson?.intentToken);
            setSelectedUpiApp(upiAppsJson?.name);
            setPkgName(upiAppsJson?.packageName);
          }
        } catch (e) {
          setSelectedUpiApp(null);
        }
      }
    }, []);
  const dispatch = useDispatch();
  const router = useRouter();
  const showCheckoutOptionsBottomSheet = useSelector(
    (state) => state?.bottomSheetReducer?.showCheckoutOptionsBottomSheet
  );
  const showSelectDynamicBundlingBottomSheet = useSelector((state) => state?.layoutReducer?.isBuyNowDoubtBuddyModalOpen);
  let courseModal = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.courseModal
  );
  const showCourseAccessRemoveBottomSheet = useSelector(
    (state) => state?.bottomSheetReducer?.showCourseAccessRemoveBottomSheet
  );

  const priceBottom = useSelector(
    (state) => state?.overviewReducer?.graphCourseData?.priceBottom
  );
  const autopayConfig = useSelector(
    (state) =>
     state?.overviewReducer?.overViewDetails?.course?.metaData?.autopayConfig
  );
  const isAutoPayEnabled = useSelector(
    (state) =>
     state?.overviewReducer?.overViewDetails?.course?.metaData?.isAutoPayEnabled || 0 
  );

  const pincodeErrorMsg = useSelector(
    (state) => state?.physicalShipmentReducer?.picodeErrorMessage
  );
  const whatsappPaymentLoading = useSelector(
    (state) => state?.overviewReducer?.whatsappPaymentLoading
  );
  const isPhysicalDeliveryEnabled = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData
        ?.isPhysicalDeliveryEnabled
  );
  const bundles = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.bundleData
        ?.bundles
  );
  const isBooksAdded = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.bundleData
        ?.isBooksAdded
  );
  const isDynamicBundlingEnabled = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData
        ?.isDynamicBundlingEnabled
  );
  const disableBuyNowBtn = useSelector(
    (state) => state?.physicalShipmentReducer?.disableBuyNowBtn
  );

  const pricingDetailsLoading = useSelector(
    (state) => state?.overviewReducer?.graphCourseDataLoading
  );
  const data = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.installments
  );
  const orgId = useSelector((state) => state?.overviewReducer?.overViewDetails?.course
  ?.metaData?.orgId)
  const overViewData = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course
  );
  const isComboActive = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData?.isComboActive
  );
  const paymentData = useSelector((state) => state?.overviewReducer);

  const activeAddress = useSelector(
    (state) => state?.physicalShipmentReducer?.activeAddress
  );
  const isUserSubscribedToFreeCourse = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData
        ?.isUserSubscribedToFreeCourse
  ) || 0;
  const canRePurchaseFreeCourse = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.metaData
        ?.canRePurchaseFreeCourse
  );
  
  const [isCheckoutBottomSheetOpen, setIsCheckoutBottomSheetOpen] =
    useState(false);

  useEffect(() => {
    if (courseModal?.hasBuyNow) {
      dispatch(showCourseAccessRemoveBottomSheetAction(true));
    }
  }, [courseModal?.hasBuyNow]);
  const purchaseViaWhatsapp = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsapp
  );
  const purchaseViaWhatsappV2 = useSelector(
    (state) =>
      state?.overviewReducer?.overViewDetails?.course?.purchaseViaWhatsappV2
  );
  const courseId = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.metaData?.id
  );
  const introVideoData = useSelector(
    (state) => state?.overviewReducer?.overViewDetails?.course?.introVideoData || {}
  );
  const introVideoId = introVideoData?.contentId;
  const token = localStorage.getItem("userToken");
  const showIntroVideoBottomSheet = useSelector(
    (state) => state?.bottomSheetReducer?.showIntroVideoBottomSheet || 0
  );

  const isPaymentCancel = useSelector((state) => state.bottomSheetReducer?.isIdysPaymentRejected);

  const handlePaymentSucess = () => {
    handleBuyNowClick();
  };
  const { t } = useTranslation();

  const handleControlIdfyEmailVerification = () => {
    setIsIdfyEmailVerificationEnabled(false);
    setIsIdfyUserVerified(true);
  };

  useEffect(() => {
    let fromLiveCourse = new URLSearchParams(window?.location?.search).get(
      "fromLiveCourse"
    );
    setShareableLiveClassEventType(fromLiveCourse);
    if (fromLiveCourse === "coupon" || fromLiveCourse === "buy_now") {
      router.push(window.location.pathname, undefined, {
        shallow: true,
      });
    }
  }, []);

  useEffect(()=>{
    if(shareableLiveClassEventType === 'coupon'){
      dispatch(showApplyCouponBottomSheetAction(true))
      setShareableLiveClassEventType("")
    }
    else if(priceBottom?.finalPrice && shareableLiveClassEventType === 'buy_now'){
      handleBuyNowClick()
      setShareableLiveClassEventType("")
    }
  },[shareableLiveClassEventType , priceBottom?.finalPrice])
  // console.log("+++pricingDetailsLoading", pricingDetailsLoading);
  const openInstallments = () => {
    // console.log(paymentData, "paymentData");
    openInstallmentUtil();

    if (typeof buttonText === "string" && buttonText.includes("Pending")) {
      newWebEngage("course_pay_via_installments_with_pending_amount", {
        action: "Pending Instalments Click",
        course_name: `${overViewData?.details?.name}`,
        pending_instalment_amount: Number(
          paymentData?.individualInstallmentData?.purchaseButton?.amount / 100
        ),
        course_price: Number(
          paymentData?.individualInstallmentData?.courseInfo?.priceSummary
            ?.coursePrice / 100
        ),
        final_amount: Number(
          paymentData?.individualInstallmentData?.courseInfo?.priceSummary
            ?.effectivePrice / 100
        ),
      });
    }

    // console.log(data);
    // directDeepLink(
    //   {},
    //   "UTIL_WEBVIEW",
    //   false
    // )(data?.installmentAlert?.button?.deeplink);
  };

  if (isInstallment) {
    return (
      <>
        {children}
        <div className={`${styles.layout__footer__buyNow}`}>
          <div
            className={`${styles.layout__footer__buyNow__button} ${styles.fullWidth}`}
          >
            <Button
              customClassName="buttonShine buyNowShine"
              onClick={() => {
                openInstallments();
              }}
            >
              {buttonText}
            </Button>
          </div>
        </div>
      </>
    );
  }

  const handleBuyNowClick = async (isIntentCaptured) => {
    if (showIntroVideoBottomSheet === 1) {
      dispatch({
        type: CONSTANTS.SET_SHOW_INTRO_VIDEO_BOTTOM_SHEET,
        payload: 0
      });
      await updateIntroVideo({ courseId, introVideoId, token });
    }
    let deviceInfo = safeJsonParse(window?.androidData, {
      source: "BuyNowFooter [window.androidData]",
      fallback: null,
    });
        let version = deviceInfo?.deviceInfo?.sdk
    if (version && version < 24 && (orgId == 573212 || orgId == 170)) {
      return dispatch(setNotSupportedBottomsheet(true));
    }
    if(isFreeCourse){
      dispatch(showCourseAccessRemoveBottomSheetAction(false));
      if(isUserSubscribedToFreeCourse || (!isUserSubscribedToFreeCourse && !canRePurchaseFreeCourse)){
        return dispatch(showLockedFreeCourseBottomSheetAction(true))
      }
      return dispatch(showEnrollForFreeCourseBottomSheetAction(true))
    }
    if (isDynamicBundlingEnabled) {
      dispatch(showSelectDynamicBundlingBottomSheetAction(true));
    } else {
      if (purchaseViaWhatsapp) {
        const payload = {
          courseId: courseId,
          courseName: overViewData?.details?.name,
        };
        newWebEngage("course_interested_whatsapp_click", {
          sub_source_id: courseId,
        });
        dispatch(captureInterest(payload));
      } else if (isComboActive === 1) {
        dispatch(courseFacultyListModalAction(true));
      } else if (purchaseViaWhatsappV2 === 1) {
        newWebEngage("course_interested_whatsapp_click", {
          sub_source_id: courseId,
        });
      
        initialisePaymentService(null,null,{
          upiIntentToken: isIntentCaptured ? intentToken:  null 
        });
      } else {
        initialisePaymentService(null,null,{
          upiIntentToken: isIntentCaptured ? intentToken:  null 
        });
      }
    }
    if(showSelectDynamicBundlingBottomSheet){
      dispatch(showApplyCouponBottomSheetAction(false))
    }
  };

  const handleBuyClick = async(upiIntentOption) => {
    if (showIntroVideoBottomSheet === 1) {
      dispatch({
        type: CONSTANTS.SET_SHOW_INTRO_VIDEO_BOTTOM_SHEET,
        payload: 0,
      });
      await updateIntroVideo({ courseId, introVideoId, token });
    }
    if(overViewData?.metaData?.verificationDetails?.prePurchase?.isVerificationRequired) {
      setIsIdfyEmailVerificationEnabled(true)
    } else {
       handleBuyNowClick(upiIntentOption);
    }
  };
  const getTrialUnit = () => {
    if(autopayConfig?.trialUnit==1){
      return autopayConfig?.trialPeriod == 1 ? 'day' : 'days'
    } else if(autopayConfig?.trialUnit==2){
      return autopayConfig?.trialPeriod == 1 ? 'month' : 'months'
    } else if(autopayConfig?.trialUnit==3){
      return autopayConfig?.trialPeriod == 1 ? 'year' : 'years'
    } else {
      return ''
    }
  }
  const selectAddress = () => {
      dispatch(actionCreator.showSelectAddressBottomSheetAction(true));
  };

  const getUpiIcon = (upiPkgName) => {
    return UPI_APP_ICONS[upiPkgName] || UPI_APP_ICONS["default"];
  }
  // Function to get Buy Now button text
  const getBuyNowButtonText = () => {
    if (isFreeCourse) {
      return t(
        "components.bottomSheets.components.contentLockedBottomSheet.getThisFreeCourse",
        "Get this course for FREE"
      );
    }
    if (autopayConfig && isAutoPayEnabled && Object.keys(autopayConfig).length) {
      return `Start ${autopayConfig.trialPeriod} ${getTrialUnit()} Trial`;
    }
    if (isOneTimeCheckoutEnabled && selectedUpiApp) {
      return `Buy at ${priceBottom?.finalPrice}`;
    }
    if (purchaseViaWhatsapp || purchaseViaWhatsappV2 === 1) {
      return "I'm interested";
    }
    return t(
      "components.bottomSheets.components.contentLockedBottomSheet.buyNow",
      "Buy now"
    );
  };

  return (
    <>
      {children}
      {activeAddress && isPhysicalDeliveryEnabled ? (
        <div className={styles.addressBar} >
          <div className={styles.addressLeft}>
            <Image
                  src={getAwsAssets("locationIcon.svg", "bottomSheets")}
                  alt="c"
                  height={16.5}
                  width={20}
                  priority={true}
                  loading="eager"
                />
            <p className={styles.addressText}> 
              {activeAddress?.address1}, {activeAddress?.city},{" "}
              {activeAddress?.state}, {activeAddress?.pinCode}
            </p>
          </div>

          <span className={styles.addressChange} onClick={selectAddress}>Change</span>
        </div>
      ) : null}
      {isIdfyEmailVerificationEnabled ? (<PrepurchageIdfys setIsIdfyEmailVerificationEnabled={setIsIdfyEmailVerificationEnabled} handlePaymentSucess={handlePaymentSucess} emailVerifyAction={handleControlIdfyEmailVerification} />) : null}
      <div className={styles.layout__footer__buyNow}>
        {
          isOneTimeCheckoutEnabled && selectedUpiApp? (
            <div className={`${styles.layout__footer__buyNow_psp}`}>
              <h3 style={{ display: 'flex', alignItems: 'center', marginBottom: '4px' }}>
                Pay using
                
                <img
                  src="https://cdn-cp-assets-public.classplus.co/web/courseWebview/content/Chevron-2-4-26.png"
                  alt="Dropdown"
                  width={18}
                  height={18}
                  style={{ marginLeft: 4, cursor: 'pointer' }}
                  onClick={() => {
                    if(isPaymentCancel || isIdfyUserVerified){
                      handleBuyNowClick();
                    } else {
                      handleBuyClick();
                    }
                  }}
                />
              </h3>
              {selectedUpiApp ? (
                <div className={styles.layout__footer__buyNow__price}>
                  <span style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                    
                    {selectedUpiApp && (
                      <img
                        src={getUpiIcon(pkgName)}
                        alt={selectedUpiApp || 'PSP Icon'}
                        style={{ height: 20, width: 20, verticalAlign: 'middle' }}
                      />
                    )}
                    <span>{selectedUpiApp}</span>
                  </span>
                </div>
              ) : null}
            </div>
          )
         : pricingDetailsLoading ? (
          <Loader minHeight={52} minWidth={144} />
        ) : (isAutoPayEnabled ) ? (
          <div className={`${styles.layout__footer__buyNow__price} ${isFreeCourse ? styles.layout__footer__buyNow__noPrice : ''}`}>
             <div className={styles.layout__footer__buyNow__price__autopay}>
            <h3>{ autopayConfig && autopayConfig.trialAmountInRs ? `₹${autopayConfig.trialAmountInRs}` : priceBottom?.finalPrice }</h3>
             </div>
             <div className={styles.layout__footer__buyNow__price__autopaytrial}>
               <p>{`Renews at ${priceBottom?.finalPrice} for ${overViewData?.details?.duration.toLowerCase()}`}</p>
             </div>
          </div>
        )  : (
          <div className={`${styles.layout__footer__buyNow__price} ${isFreeCourse ? styles.layout__footer__buyNow__noPrice : ''}`}>
            <h3>{priceBottom?.finalPrice}</h3>
            {priceBottom?.decoratedText ? (
              <div className={styles.layout__footer__buyNow__price__discount}>
                {priceBottom?.decoratedText ? (
                  <p> {priceBottom?.decoratedText}</p>
                ) : (
                  ""
                )}
                <span>{priceBottom?.discountPer}</span>
              </div>
            ) : null}
          </div>
        )}
        {
          //TODO BUY NOW BUTTON NOT CLICKABLE IN LOADING
        }
        {showCourseAccessRemoveBottomSheet && (
          <CourseAccessRemovedBottomSheet
            mainText={courseModal?.heading}
            imageUrl={courseModal?.imageUrl}
            subText={courseModal?.description}
            btnText={
              isFreeCourse ? 
                t("components.bottomSheets.components.contentLockedBottomSheet.getThisFreeCourse", "Get this course for FREE")
                :
              courseModal?.hasBuyNow
                ? `Buy Now for ${priceBottom?.finalPrice}/-`
                : "Go Back"
            }
            btnAction={() => {
              if (courseModal?.hasBuyNow) {
                handleBuyNowClick();
              } else {
                dispatch(showCourseAccessRemoveBottomSheetAction(false));
                quitWebviewDeeplink();
              }
            }}
            goBackInstead={
              courseModal?.hasBuyNow
                ? t(
                    "components.bottomSheets.components.contentLockedBottomSheet.goBackInstead",
                    "Go back instead"
                  )
                : ""
            }
            handleClose={() =>
              dispatch(showCourseAccessRemoveBottomSheetAction(false))
            }
          />
        )}
        <div className={`${styles.layout__footer__buyNow__button} ${isFreeCourse ? styles.layout__footer__buyNow__FreeCourseButtonWrapper : ''} ${isOneTimeCheckoutEnabled ? styles.layout__footer__buyNow__PSPWrapper : ''}`}>
          <Button
            customClassName={`buttonShine buyNowShine ${styles.layout__footer__buyNow__FreeCourseButton}`}
            style={
              purchaseViaWhatsapp || purchaseViaWhatsappV2 === 1 || isAutoPayEnabled
                ? { padding: 9, fontSize: 13 }
                : {}
            }
            disabled={
              (disableBuyNowBtn &&
                activeAddress?.id &&
                isPhysicalDeliveryEnabled == 2) ||
              (bundles?.length > 0 &&
                activeAddress?.id &&
                !activeAddress?.email &&
                isBooksAdded) ||
              whatsappPaymentLoading
            }
            onClick={() => {
              if(isPaymentCancel || isIdfyUserVerified){
                handleBuyNowClick(intentToken ? 1 : 0);
              } else {
                handleBuyClick(intentToken ? 1 : 0);
              }
            }}
          >
            {getBuyNowButtonText()}
          </Button>
        </div>
      </div>
      {showSelectDynamicBundlingBottomSheet ? <LockedModal  handleModal={()=>{}} handleItemClicked={handleBuyNowClick}/> : null }
      {showCheckoutOptionsBottomSheet && <CheckoutOptionsBottomSheet />}
    </>
  );
}

export default BuyNowFooter;
